import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { SarLabAuthProvider } from './contexts/SarLabAuthContext';
import { ChatProvider } from './contexts/ChatContext';
import { LiveSupportProvider } from './contexts/LiveSupportContext';
import CardNav from './components/CardNav';
import Footer from './components/Footer';
import ChatWidget from './components/ChatWidget';
import BackgroundEffects from './components/BackgroundEffects';

// Auth & Admin
import Login from './pages/Login';
import Register from './pages/Register';
import Profile from './pages/Profile';
import AdminPanel from './pages/AdminPanel';

// Etkinlikler
import Etkinlikler from './pages/Etkinlikler';
import Turnuvalar from './pages/Turnuvalar';
import Promosyonlar from './pages/Promosyonlar';

// Slotlar
import Slotlar from './pages/Slotlar';
import SlotLobby from './pages/SlotLobby';
import SlotPopuler from './pages/SlotPopuler';
import SlotYeni from './pages/SlotYeni';
import SlotFreeSpin from './pages/SlotFreeSpin';

// Canlı Casino
import CanliCasino from './pages/CanliCasino';
import CanliLobi from './pages/CanliLobi';
import MasaOyunlari from './pages/MasaOyunlari';
import Rulet from './pages/Rulet';
import Blackjack from './pages/Blackjack';

// Sponsorlar
import Sponsors from './pages/Sponsors';
import SponsorApply from './pages/SponsorApply';

// Spor Bahisleri
import SporBahisleri from './pages/SporBahisleri';
import SporCanli from './pages/SporCanli';
import SporYaklasan from './pages/SporYaklasan';
import SporFutbol from './pages/SporFutbol';
import SporBasketbol from './pages/SporBasketbol';

// Diğer
import Diger from './pages/Diger';
import VPN from './pages/VPN';
import Blog from './pages/Blog';
import Uygulama from './pages/Uygulama';
import CanliDestek from './pages/CanliDestek';

// Legal & Other
import TermsOfService from './pages/TermsOfService';
import PrivacyPolicy from './pages/PrivacyPolicy';
import Contact from './pages/Contact';
import NotFound from './pages/NotFound';

function App() {
  return (
    <SarLabAuthProvider>
      <ChatProvider>
        <LiveSupportProvider>
          <Router>
          <div className="min-h-screen bg-transparent flex flex-col">
            <BackgroundEffects />
            <CardNav />
            <main className="flex-1">
              <Routes>
                {/* Ana Sayfa - Etkinlikler */}
                <Route path="/" element={<Etkinlikler />} />

                {/* Etkinlikler */}
                <Route path="/etkinlikler" element={<Etkinlikler />} />
                <Route path="/etkinlikler/turnuvalar" element={<Turnuvalar />} />
                <Route path="/etkinlikler/promosyonlar" element={<Promosyonlar />} />

                {/* Slotlar */}
                <Route path="/slotlar" element={<Slotlar />} />
                <Route path="/slotlar/lobby" element={<SlotLobby />} />
                <Route path="/slotlar/populer" element={<SlotPopuler />} />
                <Route path="/slotlar/yeni" element={<SlotYeni />} />
                <Route path="/slotlar/free-spin" element={<SlotFreeSpin />} />

                {/* Canlı Casino */}
                <Route path="/canli-casino" element={<CanliCasino />} />
                <Route path="/canli-casino/lobi" element={<CanliLobi />} />
                <Route path="/canli-casino/masa-oyunlari" element={<MasaOyunlari />} />
                <Route path="/canli-casino/rulet" element={<Rulet />} />
                <Route path="/canli-casino/blackjack" element={<Blackjack />} />

                {/* Sponsorlar */}
                <Route path="/sponsors" element={<Sponsors />} />
                <Route path="/sponsors/apply" element={<SponsorApply />} />

                {/* Spor Bahisleri */}
                <Route path="/spor-bahisleri" element={<SporBahisleri />} />
                <Route path="/spor-bahisleri/canli" element={<SporCanli />} />
                <Route path="/spor-bahisleri/yaklasan" element={<SporYaklasan />} />
                <Route path="/spor-bahisleri/futbol" element={<SporFutbol />} />
                <Route path="/spor-bahisleri/basketbol" element={<SporBasketbol />} />

                {/* Diğer */}
                <Route path="/diger" element={<Diger />} />
                <Route path="/diger/vpn" element={<VPN />} />
                <Route path="/diger/blog" element={<Blog />} />
                <Route path="/diger/uygulama" element={<Uygulama />} />
                <Route path="/diger/canli-destek" element={<CanliDestek />} />

                {/* Auth */}
                <Route path="/login" element={<Login />} />
                <Route path="/register" element={<Register />} />
                <Route path="/profile" element={<Profile />} />
                <Route path="/admin" element={<AdminPanel />} />

                {/* Legal & Other */}
                <Route path="/terms-of-service" element={<TermsOfService />} />
                <Route path="/privacy-policy" element={<PrivacyPolicy />} />
                <Route path="/contact" element={<Contact />} />

                {/* 404 */}
                <Route path="*" element={<NotFound />} />
              </Routes>
            </main>
            <Footer />
            <ChatWidget />
          </div>
        </Router>
        </LiveSupportProvider>
      </ChatProvider>
    </SarLabAuthProvider>
  );
}

export default App;
